<div class="owp-container">
  <div class="signifyBookmd"><strong>OEM Write Protected features</strong></div>

  <div class="row mt-2">
    <div class="col-3">
      <div>
        <div class="row mt-4">
          <div class="col-9 filter-list signifyBookmd mt-1 item-owp-wd">
            {{ isSelectAll ? "(De)Select All" : "Select All" }}
          </div>
          <div class="col-2">
            <label class="enable-feature" aria-hidden="true">
              <input type="checkbox" (change)="selectAll($event.target.checked)" [checked]="isSelectAll"
                name="selectAll" class="primary-checkbox" id="selectAll" aria-label="Select All" />
                <span id="OWP-selectAll-checkbox" class="extra-border-enablefeat"></span></label>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="mt-2 row">
    <ng-container [ngTemplateOutlet]="checkboxContainer" [ngTemplateOutletContext]="{
        startIndex: 0,
        endIndex: getRoundOff(owpAvailableFeatures.length / 2)
      }"></ng-container>
    <ng-container [ngTemplateOutlet]="checkboxContainer" [ngTemplateOutletContext]="{
        startIndex: getRoundOff(owpAvailableFeatures.length / 2),
        endIndex: owpAvailableFeatures.length
      }"></ng-container>
      </div>

      <div class="signifyBookmd mt-4">
        Set OWP Password
        <img class="info" src="{{ pathVal }}info.png" placement="right" [autoClose]="'outside'" [ngbTooltip]="Config"
          triggers="click:blur" tooltipClass="my-aoc-class clo-container" #owp="ngbTooltip" (click)="[owp.open()]" (keydown.enter)="[owp.open()]" (keydown.space)="[owp.open()]; $event.preventDefault()"  alt="Information" />
          <ng-template #Config>
            <div class="row app-area-container">
              <div class="col-9 title-tooltip"></div>
              <div class="col-3 tooltip-image">
                <img src="{{ pathVal }}close.png" (click)="[owp.close()]" (keydown.enter)="[owp.close()]" (keydown.space)="[owp.close()]; $event.preventDefault()"  alt="Close" />
              </div>
              <br />
              <p class="tooltip-description">
                The password must contain 4 numbers between 0-255. 4 times 0 or 255 is
                not allowed.
              </p>
            </div>
          </ng-template>
        </div>

        <div class="password-form mb-40" [formGroup]="owpPasswordForm">
          <div class="row mt-2">
            <div class="col-12">
              <div>
                <div class="row mt-4">
                  <div class="col-1 filter-list signifyBookmd mt-2">
                    New <br />Password
                  </div>
                  <div class="col-10 mt-2 row ml-0 mr-0 pwd-row-container">
                    <div class="col-1-width pwd-wrapper ml-1">
                      <input #newPwd1 apInputError [validOnDisbale]="true" [formControl]="owpPasswordForm.get('p1')" id="p1"
                        [type]="showNewPasswords ? 'text' : 'password'" [title]="'Value must be between 0 and 255'"
                        appOnlynumber formControlName="p1" class="pwd col-1 w-100 input-element form-control" minlength="1"
                        maxlength="3" (input)="onAutoAdvance('p1', newPwd2)"
                        (keydown)="onBackspaceNavigate($event, null, 'p1')" />
                      </div>
                      <div class="col-1-width pwd-wrapper ml-2">
                        <input #newPwd2 apInputError [validOnDisbale]="true" [formControl]="owpPasswordForm.get('p2')" id="p2"
                          [type]="showNewPasswords ? 'text' : 'password'" [title]="'Value must be between 0 and 255'"
                          appOnlynumber formControlName="p2" class="pwd col-1 w-100 input-element form-control" minlength="1"
                          maxlength="3" (input)="onAutoAdvance('p2', newPwd3)"
                          (keydown)="onBackspaceNavigate($event, newPwd1, 'p2')" />
                        </div>
                        <div class="col-1-width pwd-wrapper ml-2">
                          <input #newPwd3 apInputError [validOnDisbale]="true" [formControl]="owpPasswordForm.get('p3')" id="p3"
                            [type]="showNewPasswords ? 'text' : 'password'" [title]="'Value must be between 0 and 255'"
                            appOnlynumber formControlName="p3" class="pwd col-1 w-100 input-element form-control" minlength="1"
                            maxlength="3" (input)="onAutoAdvance('p3', newPwd4)"
                            (keydown)="onBackspaceNavigate($event, newPwd2, 'p3')" />
                          </div>
                          <div class="col-1-width pwd-wrapper ml-2">
                            <input #newPwd4 apInputError [validOnDisbale]="true" [formControl]="owpPasswordForm.get('p4')" id="p4"
                              [type]="showNewPasswords ? 'text' : 'password'" [title]="'Value must be between 0 and 255'"
                              appOnlynumber formControlName="p4" class="pwd col-1 w-100 input-element form-control" minlength="1"
                              maxlength="3" (input)="onAutoAdvance('p4', null)"
                              (keydown)="onBackspaceNavigate($event, newPwd3, 'p4')" />
                            </div>
                            <button id="OWP-newPassword-visibility-toggle" type="button" class="pwd-toggle-wrapper ml-2" (click)="toggleShowNewPasswords()" (keydown.enter)="toggleShowNewPasswords()" (keydown.space)="toggleShowNewPasswords(); $event.preventDefault()"
                              [title]="showNewPasswords ? 'Hide password' : 'Show password'" [disabled]="checkForDefault()">
                              @if (!showNewPasswords) {
                                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20"
                                  viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                  stroke-linejoin="round">
                                  <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path>
                                  <circle cx="12" cy="12" r="3"></circle>
                                </svg>
                              }
                              @if (showNewPasswords) {
                                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20"
                                  viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                  stroke-linejoin="round">
                                  <path
                                    d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24">
                                  </path>
                                  <line x1="1" y1="1" x2="23" y2="23"></line>
                                </svg>
                              }
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="row mt-2">
                    <div class="col-12">
                      <div>
                        <div class="row mt-4">
                          <div class="col-1 filter-list signifyBookmd mt-2">
                            Verify <br />Password
                          </div>
                          <div class="col-10 mt-2 row ml-0 mr-0 pwd-row-container">
                            <div class="col-1-width pwd-wrapper ml-1">
                              <input #verifyPwd1 apInputError [validOnDisbale]="true" [formControl]="owpPasswordForm.get('vp1')"
                                id="vp1" [type]="showVerifyPasswords ? 'text' : 'password'"
                                [title]="'Value must be between 0 and 255'" appOnlynumber formControlName="vp1"
                                class="pwd col-1 w-100 input-element form-control" minlength="1" maxlength="3"
                                (input)="onAutoAdvance('vp1', verifyPwd2)" (keydown)="onBackspaceNavigate($event, null, 'vp1')" />
                              </div>
                              <div class="col-1-width pwd-wrapper ml-2">
                                <input #verifyPwd2 apInputError [validOnDisbale]="true" [formControl]="owpPasswordForm.get('vp2')"
                                  id="vp2" [type]="showVerifyPasswords ? 'text' : 'password'"
                                  [title]="'Value must be between 0 and 255'" appOnlynumber formControlName="vp2"
                                  class="pwd col-1 w-100 input-element form-control" minlength="1" maxlength="3"
                                  (input)="onAutoAdvance('vp2', verifyPwd3)"
                                  (keydown)="onBackspaceNavigate($event, verifyPwd1, 'vp2')" />
                                </div>
                                <div class="col-1-width pwd-wrapper ml-2">
                                  <input #verifyPwd3 apInputError [validOnDisbale]="true" [formControl]="owpPasswordForm.get('vp3')"
                                    id="vp3" [type]="showVerifyPasswords ? 'text' : 'password'"
                                    [title]="'Value must be between 0 and 255'" appOnlynumber formControlName="vp3"
                                    class="pwd col-1 w-100 input-element form-control" minlength="1" maxlength="3"
                                    (input)="onAutoAdvance('vp3', verifyPwd4)"
                                    (keydown)="onBackspaceNavigate($event, verifyPwd2, 'vp3')" />
                                  </div>
                                  <div class="col-1-width pwd-wrapper ml-2">
                                    <input #verifyPwd4 apInputError [validOnDisbale]="true" [formControl]="owpPasswordForm.get('vp4')"
                                      id="vp4" [type]="showVerifyPasswords ? 'text' : 'password'"
                                      [title]="'Value must be between 0 and 255'" appOnlynumber formControlName="vp4"
                                      class="pwd col-1 w-100 input-element form-control" minlength="1" maxlength="3"
                                      (input)="onAutoAdvance('vp4', null)" (keydown)="onBackspaceNavigate($event, verifyPwd3, 'vp4')" />
                                    </div>
                                    <button id="OWP-verifyPassword-visibility-toggle" type="button" class="pwd-toggle-wrapper ml-2" (click)="toggleShowVerifyPasswords()" (keydown.enter)="toggleShowVerifyPasswords()" (keydown.space)="toggleShowVerifyPasswords(); $event.preventDefault()"
                                      [title]="showVerifyPasswords ? 'Hide password' : 'Show password'" [disabled]="checkForDefault()">
                                      @if (!showVerifyPasswords) {
                                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20"
                                          viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                          stroke-linejoin="round">
                                          <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path>
                                          <circle cx="12" cy="12" r="3"></circle>
                                        </svg>
                                      }
                                      @if (showVerifyPasswords) {
                                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20"
                                          viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                          stroke-linejoin="round">
                                          <path
                                            d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24">
                                          </path>
                                          <line x1="1" y1="1" x2="23" y2="23"></line>
                                        </svg>
                                      }
                                    </button>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <ng-template #checkboxContainer let-start="startIndex" let-end="endIndex">
                        <div class="col-3">
                          @for (item of owpAvailableFeatures.slice(start, end); track item; let i = $index) {
                            <div>
                              <div class="row mt-4">
                                <div [attr.id]="'OWP-feature-text-' + item" class="col-9 filter-list signifyBookmd mt-1 item-owp-wd">
                                  {{ maskWebNames[item] }}
                                </div>
                                <div class="col-2">
                                  <label class="enable-feature" aria-hidden="true">
                                    <input type="checkbox" class="primary-checkbox" [id]="item + 'checkbox'" [name]="item"
                                      [(ngModel)]="selectedFeatures[item]" [checked]="selectedFeatures[item]"
                                      (ngModelChange)="onCheckboxChange(item)" aria-label="owp-checkbox" />
                                      <span [attr.id]="'OWP-feature-checkbox-' + item" class="extra-border-enablefeat"></span></label>
                                    </div>
                                  </div>
                                </div>
                              }
                            </div>
                          </ng-template>

                          <ng-template #passwordContainer let-controlNames="controls">
                            <div class="password-controls" [formGroup]="owpPasswordForm">
                              <div class="col-10 mt-2 row ml-0 mr-0">
                                @for (controlName of controlNames; track controlName) {
                                  <div class="col-1-width mr-3">
                                    <input apInputError [validOnDisbale]="true" [formControl]="owpPasswordForm.get(controlName)"
                                      [id]="controlName" type="password" appOnlynumber [formControlName]="controlName"
                                      class="pwd col-1 w-100 input-element form-control" minlength="1" maxlength="3" />
                                    </div>
                                  }
                                </div>
                              </div>
                            </ng-template>
